const initialState = {
  blogs: [],
  isLoading: null,
  isError: null,
  page: 1,
  isNull: null,
};

export default initialState;
